import request from 'assets/js/http';

// kp-seed查询kp单人详情
export function getSeedKpDetail(data) {
  return request({
    url: '/kp/getSeedKpDetail',
    method: 'post',
    data
  });
}

// kp-seed查询kp的list
export function getSeedKpList(data) {
  return request({
    url: '/kp/getSeedKpList',
    method: 'post',

    data
  });
}

// kp-KP字段提交
export function setKpField(data) {
  return request({
    url: '/kp/setKpField',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

// kp-KP字段修改
export function updateKpField(data) {
  return request({
    url: '/kp/updateKpField',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

// 删除kp
export function deleteKp(data) {
  return request({
    url: '/kp/deleteSeedKp',
    method: 'post',
    data
  });
}

// 获取选人kplist
export function getSimpleKpList(data) {
  return request({
    url: '/kp/getSimpleKpList',
    method: 'post',
    data
  });
}

// 查询项目kplist
export function getCompanyKpList(data) {
  return request({
    url: '/kp/getCompanyKpList',
    method: 'post',
    data
  });
}

// 查询项目kplist
export function addKpToCompany(data) {
  return request({
    url: '/kp/addKpToCompany',
    method: 'post',
    data
  });
}

// 查询项目kplist
export function sourceSynchronize(data) {
  return request({
    url: '/kp/sourceSynchronize',
    method: 'post',
    data
  });
}

// 获取BP列表
export function bpList(data) {
  return request({
    url: '/bp/list',
    method: 'post',
    data
  });
}

// 处理BP
export function bpOperate(data) {
  return request({
    url: '/bp/operate',
    method: 'post',
    data
  });
}

// 获取BP处理人列表
export function queryBpUser(data) {
  return request({
    url: '/bp/queryBpUser',
    method: 'post',
    data
  });
}

// 获取BP赛道
export function queryBpSector(data) {
  return request({
    url: '/common/queryBpSector',
    method: 'post',
    data
  });
}

// kp修改ceo适合度是填写原因
export function onUpdateCEOSuitability(data) {
  return request({
    url: '/kp/onUpdateCEOSuitability',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

// pm修改kp评级
export function gradeByPm(data) {
  return request({
    url: '/kp/gradeByPm',
    method: 'post',
    data
  });
}
